// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #F5F7F8 !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}



.btn-alert:hover {
  background-color: #444443;
  /* slightly darker on hover */
}


.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.avatar-circle-small {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.85rem;
  flex-shrink: 0;
}

.comments-section {
  padding: 1rem;
  background: #fff;
  border-radius: 8px;
}

.comments-section .card {
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.comments-section .card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn-link:hover {
  text-decoration: underline !important;
}

.replies-container {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
}

.reply-item:last-child {
  border-bottom: none !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}



.MuiPaper-root {
  background-color: transparent !important;
  box-shadow: none !important;
}


.MUIDataTable-paper {
  background-color: transparent !important;
}


.MUIDataTable-responsiveBase {
  background-color: transparent !important;
}

.MuiTableHead-root {
  background-color: transparent !important;
}


.MuiTableCell-head {
  background-color: transparent !important;
}


.MuiTableCell-body {
  background-color: transparent !important;
}


.MuiTableRow-root {
  background-color: transparent !important;
}

.emailListTable [class*="MuiToolbar-root"] {
  all: unset !important;
}


.emailListTable .MuiToolbar-root,
.emailListTable .tss-tlx3x1-MUIDataTableToolbar-root,
.emailListTable .css-hyum1k-MuiToolbar-root {
  background: transparent !important;
  min-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none !important;
}


.constact-list {
  flex-grow: 1;
  overflow-x: auto;
  width: calc(100% - 250px);
}


.form-control::placeholder {
  color: #9CA3AF !important;  
  opacity: 1;                  
}


.form-control {
  color: #292F36 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE;aACW;AACb;;;;AAIA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;;;;AAIA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;;AAGA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;;;EAGE,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;AAC7B;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;EACzB,UAAU;AACZ;;;AAGA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #F5F7F8 !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n\n.btn-alert:hover {\n  background-color: #444443;\n  /* slightly darker on hover */\n}\n\n\n.avatar-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.avatar-circle-small {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n\n.comments-section {\n  padding: 1rem;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.comments-section .card {\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.comments-section .card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.btn-link:hover {\n  text-decoration: underline !important;\n}\n\n.replies-container {\n  background-color: #f8f9fa;\n  padding: 1rem;\n  border-radius: 4px;\n}\n\n.reply-item:last-child {\n  border-bottom: none !important;\n  padding-bottom: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n\n\n.MuiPaper-root {\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n\n.MUIDataTable-paper {\n  background-color: transparent !important;\n}\n\n\n.MUIDataTable-responsiveBase {\n  background-color: transparent !important;\n}\n\n.MuiTableHead-root {\n  background-color: transparent !important;\n}\n\n\n.MuiTableCell-head {\n  background-color: transparent !important;\n}\n\n\n.MuiTableCell-body {\n  background-color: transparent !important;\n}\n\n\n.MuiTableRow-root {\n  background-color: transparent !important;\n}\n\n.emailListTable [class*=\"MuiToolbar-root\"] {\n  all: unset !important;\n}\n\n\n.emailListTable .MuiToolbar-root,\n.emailListTable .tss-tlx3x1-MUIDataTableToolbar-root,\n.emailListTable .css-hyum1k-MuiToolbar-root {\n  background: transparent !important;\n  min-height: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  box-shadow: none !important;\n}\n\n\n.constact-list {\n  flex-grow: 1;\n  overflow-x: auto;\n  width: calc(100% - 250px);\n}\n\n\n.form-control::placeholder {\n  color: #9CA3AF !important;  \n  opacity: 1;                  \n}\n\n\n.form-control {\n  color: #292F36 !important;\n  font-family: 'Noto Sans', sans-serif !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  line-height: 24px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
